export default function init(store, router) {

    if (!localStorage.getItem('shopCacheVersion') || localStorage.getItem('shopCacheVersion') != shopSetting.cacheVersion) {
        deleteCaches().then(() => {
            localStorage.setItem('shopCacheVersion', shopSetting.cacheVersion);
        });
    }

    // Response interceptor
    axios.interceptors.response.use(
        (response) => response,
        (e) => {
            if (!axios.isCancel(e) && e.response?.status == 401) {
                
                store.dispatch('auth/logout');
                router.push({ name: 'Login' });
            }

            e.__axiosIntercepted = true;
            return Promise.reject(e);
        },
    );

    // Simplified request interceptor - focusing on core functionality
    axios.interceptors.request.use((request) => {
        // Ensure headers object exists
        if (!request.headers) request.headers = {};
        if (!request.headers.common) request.headers.common = {};
        
        // Get token with fallback
        let token = store.getters['auth/accessToken'] || localStorage.getItem('shopAccessToken');
        
        // Set Authorization header if we have token - try multiple approaches
        if (token) {
            // Method 1: Set in common headers
            request.headers.common.Authorization = `Bearer ${token}`;
            // Method 2: Set directly in headers
            request.headers.Authorization = `Bearer ${token}`;
            // Method 3: Ensure it's in the request headers object
            request.headers['Authorization'] = `Bearer ${token}`;
        } else {
            delete request.headers.common?.Authorization;
            delete request.headers.Authorization;
            delete request.headers['Authorization'];
        }

        // send locale
        const userLanguage = store.getters['app/userLanguage'];
        if (userLanguage) {
            request.headers.common['Accept-Language'] = userLanguage;
        }

        return request;
    });
    
}

async function deleteCaches() {
    try {
        const keys = await window.caches.keys();
        await Promise.all(keys.map((key) => caches.delete(key)));

        console.log('deleteCache succeed');
    } catch (err) {
        console.log('deleteCache err: ', err);
    }
}
